import React, { useRef } from 'react';
import QRCodeLibrary from 'qrcode.react';
import './QRCode.css';

function QRCode() {
  const qrRef = useRef();
  const websiteOrigin = window.location.origin;
  const menuUrl = `${websiteOrigin}/?section=menu`;

  const downloadQR = () => {
    const canvas = qrRef.current.querySelector('canvas');
    const url = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = url;
    link.download = 'break-place-qr.png';
    link.click();
  };

  const printQR = () => {
    const canvas = qrRef.current.querySelector('canvas');
    const image = canvas.toDataURL('image/png');
    const printWindow = window.open();
    printWindow.document.write(`<img src="${image}" />`);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <section className="qr-section">
      <div className="qr-container">
        <h2 className="section-title">Cod QR - Acces Rapid</h2>
        
        <div className="qr-content">
          <div className="qr-info">
            <p>
              Scanati codul QR cu telefonul pentru a accesa meniul nostru si informatiile de contact.
            </p>
            <p>
              Puteti folosi acest cod pe rulota, in pliante sau pe hartiile de ambalaj.
            </p>
          </div>

          <div className="qr-display" ref={qrRef}>
            <QRCodeLibrary 
              value={menuUrl}
              size={300}
              level="H"
              includeMargin={true}
              bgColor="#1a1a1a"
              fgColor="#e0e0e0"
            />
          </div>

          <div className="qr-url">
            <p>URL: <span>{menuUrl}</span></p>
          </div>

          <div className="qr-actions">
            <button className="action-btn download" onClick={downloadQR}>
              Descarca Cod QR
            </button>
            <button className="action-btn print" onClick={printQR}>
              Tipareste Cod QR
            </button>
          </div>

          <div className="qr-instructions">
            <h3>Cum sa folosesti codul QR</h3>
            <ol>
              <li>Imprimeaza codul QR</li>
              <li>Plaseaza-l pe pliante, pe rulota sau pe ambalaj</li>
              <li>Clientii scaneaza codul cu camera telefonului</li>
              <li>Se deschide direct meniul si contactele tale</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default QRCode;
